<app-client-details-navigation *ngIf="currentItem" [clientID]="currentItem.ID"></app-client-details-navigation>

<div class="main-page-content">
  <div class="main-page-content-block">


    <div class="main-page-content-block" *ngIf="currentItem!=null">

      <div *ngFor="let item of featureSwitches; let i = index">
        <app-client-feature-switch [featureSwitch]="item" [clientID]="currentItem?.ID"></app-client-feature-switch>
      </div>
      <div class="col-12 mb-2">
        <button class="btn btn-success" [class.button-loading]="loading" (click)="save()">Save</button>
      </div>
    </div>
  </div>
</div>
